import React from 'react'
import PropTypes from 'prop-types'
import { BackgroundBubble, Theme } from '@Infowijs-eng/component-library/components'
import { useSelector } from 'react-redux'
import getPrimaryColor from '../selectors/customer/getPrimaryColor'
import InfowijsFooter from './InfowijsFooter'

function Layout({
  children,
  themeColorOverride,
}) {
  const customerPrimaryColor = useSelector(getPrimaryColor)

  const themeColor = themeColorOverride ?? customerPrimaryColor

  return (
    <>
      {themeColor && <Theme color={themeColor} />}
      <BackgroundBubble />
      <div className="flex flex-col min-h-screen relative">
        <div className="flex font-sans min-h-screen pt-6 md:pt-0 pb-20 px-4 sm:px-0">
          {children}
        </div>
        <InfowijsFooter />
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
  ]),
  themeColorOverride: PropTypes.string,
}

Layout.defaultProps = {
  children: null,
  themeColorOverride: undefined,
}

export default Layout
